import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';
import { Calendar } from 'lucide-react';

export default function CycleProgress({ cycle }) {
  if (!cycle) return null;
  
  const tournaments = cycle.key_tournaments || [];
  
  return (
    <Card className="bg-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="w-4 h-4" />
          {cycle.cycle_name}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="mb-4">
          <div className="flex justify-between text-sm mb-1">
            <span>Cycle Progress</span>
            <span>{cycle.cycle_progress_pct}%</span>
          </div>
          <Progress value={cycle.cycle_progress_pct} />
        </div>
        <div className="space-y-2">
          {tournaments.map((t, i) => (
            <div key={i} className="flex justify-between items-center p-2 rounded bg-muted/30">
              <span className="text-sm">{t.name}</span>
              <Badge variant={t.result.includes('Upcoming') ? 'outline' : 'default'}>
                {t.result}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
